import React from 'react';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as ProxyHelper from "../ProxyHelper";

class ProxyAccess extends React.Component {
    constructor(props) {
        super(props);
        const { proxyRequestData } = this.props; //if its retry option selected on failure        
        const { manageOwnHealthcare } = proxyRequestData;

        this.state = {
            manageOwnHealthcare: manageOwnHealthcare
        };
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.ProxyAccess.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    onButtonClick(success) {
        const { proxyRequestData, onProxyAccessChange, onGoNext } = this.props;
        onProxyAccessChange(success);
        if (onGoNext) {
            onGoNext(true, { ...proxyRequestData });
            this.setState({ isValid: true }, () => {
                this.props.goNext();
            });
        }
    }

    render() {
        const {  pharmacy, healthrecord, isMinor } = this.props;
        return (
            <div className="request-proxy-access-container" style={this.props.style}>
                <div className="row">
                    <div className="col-12">
                        <h1 className="step-heading step-heading-md">{healthrecord ? "Does this patient manage their own healthcare?" : ""}</h1>
                    </div>
                </div>
               
                <div className="row">
                    {healthrecord && <div className="col-12 note text-center">
                        <p>If yes, this person will need to have a MyBSWHealth account and access to their email.</p>
                        <p>If no, you will need to verify your relationship with power of attorney, legal guardianship or similar documentation for this person.</p>
                    </div>
                    }
                    
                </div>
                <div className="row">
                    <>
                        <div className="col-6 text-right">
                            <button type="button" fluid className="btn btn-primary " onClick={() => this.onButtonClick(true)}>Yes</button>
                        </div>
                        <div className="col-6">
                            <button type="button" className="btn btn-primary " onClick={() => this.onButtonClick(false)}>No</button>
                        </div>
                    </>

                </div>
            </div>
        );
    }
}

export default ProxyAccess;